import { AsyncTaskStatus } from 'src/utilities/useAsyncTask';

export type AsyncTaskStatusHandler = (
  asyncTaskStatus: AsyncTaskStatus
) => Promise<void>;

export const createAsyncStatusHandler = (
  onSuccess: () => void | Promise<void>,
  onError?: () => void | Promise<void>,
  resolvablePromise?: (value: void | PromiseLike<void>) => void
): AsyncTaskStatusHandler => {
  const resolvePromise = async (cb: () => Promise<void>): Promise<void> => {
    await cb();
    resolvablePromise?.();
  };

  const handleSuccess = async (): Promise<void> => {
    await onSuccess();
  };

  const handleError = async (): Promise<void> => {
    await onError?.();
  };

  const handleAsyncStatus = async (
    asyncTaskStatus: AsyncTaskStatus
  ): Promise<void> => {
    switch (asyncTaskStatus) {
      case AsyncTaskStatus.COMPLETE: {
        await resolvePromise(handleSuccess);
        break;
      }

      case AsyncTaskStatus.ERROR:
        await resolvePromise(handleError);
        break;

      default:
        break;
    }
  };

  return handleAsyncStatus;
};
